import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';

export const INSURANCE_INFORMATION_PATH = 'insurance-information';
export const OWNER_INITIAL_INFO_PATH = 'owner-info';
export const ONLY_SHOW_OWNER_INITIAL_INFO_PATH = 'show-owner-info';
export const OWNER_CONTACT_INFO_PATH = 'owner-contact-info';
export const VEHICLE_INFO_PATH_SHOW = 'vehicle-information-show';
export const VEHICLE_INFO_PATH = 'vehicle-information';
export const DOCUMENTS_PATH = 'initial-documents-info';
export const INITIAL_VISIT_ADJUSTER_SHOW_PATH = 'show-adjuster-visit';
export const INITIAL_VISIT_ADJUSTER_PATH = 'adjuster-visit';
export const PART_TWO = 'part-two';
export const ADJUSTER_IMAGES_PATH = 'adjuster-images';
export const INITIAL_VISIT_VEHICLE_IMAGES_PATH = 'vehicle-images';
export const INITIAL_VISIT_DOCUMENT_PATH = 'documents';
export const INITIAL_VISIT_DOCUMENT_PATH_SHOW = 'show-documents';
export const INITIAL_VISIT_ADDITIONAL_IMAGES_PATH = 'additional-images';
export const INITIAL_VISIT_ADDITIONAL_IMAGES_PATH_SHOW =
  'show-additional-images';
export const INITIAL_VISIT_FLOW_TAKE_PHOTO_GUIDE = 'flow-take-photo-guide';
export const INITIAL_VISIT_IMAGE_FLOW_PATH = 'image-flow';
export const INITIAL_VISIT_LOCAL_IMAGE_PREVIEW = 'local-image-preview';
export const INITIAL_VISIT_SERVER_IMAGE_PREVIEW = 'server-image-preview';
export const INITIAL_VISIT_SERVER_IMAGE_PREVIEW_show =
  'server-image-preview-show';
export const INITIAL_VISIT_SERVER_DAMAGED_POINTS_PATH = 'server-damaged-points';
export const INITIAL_VISIT_CUSTOMER_IMAGES = 'customer-images';
export const INITIAL_VISIT_SIGNATURE_PATH = 'signature';
export const INITIAL_VISIT_SIGNATURE_PATH_SHOW = 'show-signature';
export const INITIAL_VISIT_CORRECTIVE_IMAGES = 'corrective-images';
export const INITIAL_VISIT_INFORMATION_PATH = 'visit_information';
export const INITIAL_VISIT_ACCESSORY_PATH = 'accessory';
export const INITIAL_VISIT_ACCESSORY_FORM = 'form';
export const INITIAL_VISIT_ACCESSORY_PATH_SHOW = 'show-accessory';
export const INITIAL_VISIT_FORM_PATH = 'visit_form';
export const INITIAL_VISIT_FORM_PATH_SHOW = 'show_visit_form';

export const SHOW_INITIAL_VISIT_INFORMATION_PATH = 'visit_information-show';
export const SHOW_INITIAL_VISIT_FORM_PATH = 'visit_form-show';

export const INITIAL_VISIT_LINKS = {
  INITIAL_VISIT_TABS: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}`,
  OWNER_INITIAL_INFO: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${OWNER_INITIAL_INFO_PATH}`,
  OWNER_CONTACT_INFO: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${OWNER_CONTACT_INFO_PATH}`,
  VEHICLE_INFO: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${VEHICLE_INFO_PATH}`,
  VEHICLE_INFO_SHOW: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${VEHICLE_INFO_PATH_SHOW}`,
  DOCUMENTS: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}`,
  ADJUSTER: (id: number) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}`,
  ONLY_SHOW_OWNER_INITIAL_INFO: (id: number) => {
    return `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${ONLY_SHOW_OWNER_INITIAL_INFO_PATH}`;
  },
  PART_TWO: (id: number) => {
    return `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${VEHICLE_INFO_PATH}/${PART_TWO}`;
  },
};

export const INITIAL_IMAGES_LINKS = {
  ADJUSTER_IMAGES: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}`,
  INITIAL_VISIT_SIGNATURE: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${INITIAL_VISIT_SIGNATURE_PATH}`,
  INITIAL_VISIT_SIGNATURE_SHOW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${INITIAL_VISIT_SIGNATURE_PATH_SHOW}`,
  INITIAL_VISIT_CORRECTIVE_IMAGES: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${INITIAL_VISIT_CORRECTIVE_IMAGES}`,
};

export const INITIAL_ADJUSTER_IMAGES_LINKS = {
  INITIAL_VISIT_VEHICLE_IMAGES: {
    edit: (id: number | string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}`,
  },
  INITIAL_VISIT_DOCUMENT: {
    edit: (id: number | string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_DOCUMENT_PATH}`,
    show: (id: number | string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_DOCUMENT_PATH_SHOW}`,
  },
  INITIAL_VISIT_ADDITIONAL_IMAGES: {
    edit: (id: number | string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_ADDITIONAL_IMAGES_PATH}`,
    show: (id: number | string) =>
      `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_ADDITIONAL_IMAGES_PATH_SHOW}`,
  },
};

export const INITIAL_VISIT_ADJUSTER_IMAGES_LINKS = {
  INITIAL_VISIT_FLOW_TAKE_PHOTO_GUIDE: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}/${INITIAL_VISIT_FLOW_TAKE_PHOTO_GUIDE}`,
  INITIAL_VISIT_IMAGE_FLOW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}/${INITIAL_VISIT_IMAGE_FLOW_PATH}`,
  INITIAL_VISIT_LOCAL_IMAGE_PREVIEW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}/${INITIAL_VISIT_LOCAL_IMAGE_PREVIEW}`,
  INITIAL_VISIT_SERVER_IMAGE_PREVIEW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}/${INITIAL_VISIT_SERVER_IMAGE_PREVIEW}`,
  INITIAL_VISIT_SERVER_IMAGE_PREVIEW_SHOW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}/${INITIAL_VISIT_SERVER_IMAGE_PREVIEW_show}`,
  INITIAL_VISIT_SERVER_DAMAGED_POINTS: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${ADJUSTER_IMAGES_PATH}/${INITIAL_VISIT_VEHICLE_IMAGES_PATH}/${INITIAL_VISIT_SERVER_DAMAGED_POINTS_PATH}`,
};

export const INITIAL_VISIT_CUSTOMER_IMAGES_LINKS = {
  ENTRY_TAB: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${DOCUMENTS_PATH}/${INITIAL_VISIT_CUSTOMER_IMAGES}`,
};

export const INITIAL_VISIT_ADJUSTER_LINKS = {
  INITIAL_VISIT_ADJUSTER_BASE: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}`,
  INITIAL_VISIT_INFORMATION: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${INITIAL_VISIT_INFORMATION_PATH}`,
  SHOW_INITIAL_VISIT_INFORMATION: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${SHOW_INITIAL_VISIT_INFORMATION_PATH}`,
  INITIAL_VISIT_ACCESSORY: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${INITIAL_VISIT_ACCESSORY_PATH}`,
  INITIAL_VISIT_ACCESSORY_FORM: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${INITIAL_VISIT_ACCESSORY_PATH}/${INITIAL_VISIT_ACCESSORY_FORM}`,
  INITIAL_VISIT_ACCESSORY_SHOW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${INITIAL_VISIT_ACCESSORY_PATH_SHOW}`,
  INITIAL_VISIT_FORM: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${INITIAL_VISIT_FORM_PATH}`,
  INITIAL_VISIT_FORM_SHOW: (id: number | string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}/${INITIAL_VISIT_ADJUSTER_PATH}/${INITIAL_VISIT_FORM_PATH_SHOW}`,
};
